const styleSheet = () => ({
  revertToDefault: {
    color: '#085FE5',
    fontSize: '12px',
    fontWeight: '500',
    lineHeight: '15px',
    cursor: 'pointer',
    marginLeft: '16px',
    paddingTop: '7px',
    paddingBottom: '3px',
    userSelect: 'none',
    backgroundColor: 'transparent',
    border: 0,
  },
});

export default styleSheet;
